import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import decaActions from "../../../store/deca.actions";
import decaSelector from "../../../store/deca.selectors";
import solicitacaoSelector from "../store/solicitacao.selectors";
import solicitacaoActions from "../store/solicitacao.actions";
import documentoActions from "../../documentos/store/documento.actions";
import { ddadosSolicitacao as DDados } from "../solicitacao.ddados";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";
import apiDeca from "../../../service/deca.service";

// Component DadosCadastrais
import DadosCadastrais from "../../dadosCadastrais/container/dadoscadastrais.subform";

class Container extends Component {
  constructor(props) {
    super(props, DDados);
    autoBind(this);

    this.state = {
      modalValidacaoForm: true,
    };
  }

  componentWillMount() {
    this.props.solicitacaoActions.resetForm("", "", true);
  }

  handlerDescricaoSolicitacao = (value) =>
    this.props.solicitacaoActions.setDescricaoSolicitacao(value);

  async handleCpfCnpjBlur(value) {
    var replaceMaskNew = value && value.replace(/[\._/-]/g, "").trim();
    var qtdCpfCnpjNew = replaceMaskNew.length;

    const { solicitacaoSelector, solicitacaoActions } = this.props;
    const { solicitacao } = solicitacaoSelector;
    var cpfCnpjState = solicitacao.CpfCnpjSolicitacao
      ? solicitacao.CpfCnpjSolicitacao.replace(/[\._/-]/g, "").trim().length
      : 0;
    if (qtdCpfCnpjNew != 0) {
      if (
        value &&
        value != solicitacao.CpfCnpjSolicitacao &&
        cpfCnpjState > 0 &&
        solicitacao.CpfCnpjSolicitacao
      ) {
        const result = await _alert.confirm(
          "Houve alteração nos campos CPF/CNPJ, Tipo Solicitação e CCM, deseja realmente confirmar essa Alteração ? Note que os dados preenchidos serão perdidos.",
          "Atenção"
        );
        if (result) {
          this.setState({ modalValidacaoForm: true });
          const result = await this.props.decaActions.validarTipoEmpresa(value);
          if (result) {
            solicitacaoActions.resetForm("", "", true, "");
          } else {
            solicitacaoActions.resetForm("", "", true, value);
          }
          return;
        } else {
          solicitacaoActions.setCpfCnpjSolicitacao("");
          solicitacaoActions.setCpfCnpjSolicitacao(
            solicitacao.CpfCnpjSolicitacao
          );
          return;
        }
      }
      if (value && value != solicitacao.CpfCnpjSolicitacao) {
        this.props.decaActions.validarTipoEmpresa(value);
      }
    } else if (qtdCpfCnpjNew == 0 && cpfCnpjState != 0) {
      const result = await _alert.confirm(
        "Houve alteração nos campos CPF/CNPJ, Tipo Solicitação e CCM, deseja realmente confirmar essa Alteração ? Note que os dados preenchidos serão perdidos.",
        "Atenção"
      );
      if (result) {
        solicitacaoActions.resetForm("", "", true, value);
        return;
      } else {
        solicitacaoActions.setCpfCnpjSolicitacao("");
        solicitacaoActions.setCpfCnpjSolicitacao(
          solicitacao.CpfCnpjSolicitacao
        );
        return;
      }
    }
  }

  async onChangeTipoSolicitacao(TipoSolicitacao) {
    let { solicitacaoActions } = this.props;
    const { solicitacao } = this.props.solicitacaoSelector;
    const { modalValidacaoForm } = this.state;
    let jaExecutou = false;

    if (
      TipoSolicitacao != solicitacao.TipoSolicitacao &&
      solicitacao.TipoSolicitacao
    ) {
      this.setState({ modalValidacaoForm: false });
      const result = await _alert.confirm(
        "Houve alteração nos campos CPF/CNPJ, Tipo Solicitação e CCM, deseja realmente confirmar essa Alteração ? Note que os dados preenchidos serão perdidos.",
        "Atenção"
      );
      if (result) {
        jaExecutou = true;
        let retorno = await this.checkTipoSolicitacao(TipoSolicitacao);

        if (retorno == 1) return;
      } else {
        solicitacaoActions.setTipoSolicitacaoAtual(new Date().getTime());
        return;
      }
    }

    if (
      (modalValidacaoForm && !jaExecutou) ||
      (!modalValidacaoForm && TipoSolicitacao)
    ) {
      jaExecutou = true;
      let retorno = await this.checkTipoSolicitacao(TipoSolicitacao);
      if (retorno == 1) return;
    }

    if (TipoSolicitacao == 1 && solicitacao.itensComboboxCCM.length > 0) {
      this.setState({ modalValidacaoForm: false });
      const result = await _alert.confirm(
        "O CPF/CNPJ informado já tem cadastro de empresa municipal ativo no município. Ao prosseguir com esse tipo de solicitação o sistema gerará um novo número de CCM para o mesmo CPF/CNPJ. Deseja realmente continuar?",
        "Atenção"
      );
      if (result) {
        if (!jaExecutou) {
          let retorno = await this.checkTipoSolicitacao(TipoSolicitacao);

          if (retorno == 1) return;
        }
      } else {
        this.setState({ modalValidacaoForm: true });
        solicitacaoActions.resetForm(
          "",
          "",
          true,
          solicitacao.CpfCnpjSolicitacao,
          false
        );
        return;
      }
    }
  }

  async checkTipoSolicitacao(TipoSolicitacao) {
    let { form, routerManager } = this.props;
    const { CpfCnpjSolicitacao, CCM } = form.values;
    const { solicitacao } = this.props.solicitacaoSelector;
    const { id } = routerManager.params;

    if (TipoSolicitacao != (undefined || "") && !id) {
      this.props.solicitacaoActions.resetForm("", TipoSolicitacao);

      if (TipoSolicitacao == 1 && CpfCnpjSolicitacao) {
        return await this.dadosSolicitacao(
          CpfCnpjSolicitacao,
          TipoSolicitacao,
          undefined
        );
      }
    }
    if (TipoSolicitacao == (undefined || "")) {
      this.props.solicitacaoActions.resetForm("", TipoSolicitacao);
      this.props.solicitacaoActions.setSolicitacao({
        TipoSolicitacao,
        CCM:
          TipoSolicitacao == "" || TipoSolicitacao == undefined
            ? undefined
            : CCM,
      });
    }
    if (CpfCnpjSolicitacao && CCM && TipoSolicitacao) {
      this.props.solicitacaoActions.setSolicitacao({
        CpfCnpjSolicitacao,
        TipoSolicitacao,
        CCM:
          TipoSolicitacao == "" || TipoSolicitacao == undefined
            ? undefined
            : CCM,
      });
    }

    if (
      solicitacao.itensComboboxCCM.length < 1 &&
      TipoSolicitacao != 1 &&
      TipoSolicitacao
    ) {
      _showError(
        "O CPF/CNPJ digitado não tem empresa vinculada na base de dados da prefeitura, neste caso é permitido somente solicitar seu cadastramento. Utilize o tipo de solicitação de 'Cadastro'."
      );
      this.props.solicitacaoActions.setCCMTipoSolicitacao("", "");
      return;
    }
  }

  async dadosSolicitacao(CpfCnpjSolicitacao, TipoSolicitacao, ccm) {
    this.props.decaActions.setDisableAllSolicitacao(false);
    try {
      const responseSolicitacaoDados = await apiDeca.solicitacaoDadosByCpfCnpj({
        CpfCnpjSolicitacao,
        ccm,
        TipoSolicitacao,
      });

      const { data } = responseSolicitacaoDados;

      const dto = { ...data, CpfCnpjSolicitacao, ccm, TipoSolicitacao };

      if(dto.SituacaoCcm && dto.SituacaoCcm != "Ativo")
        await _alert.warning("O CCM está com a situação diferente de Ativo");

      this.props.decaActions.getDadosSolicitacao(dto);
    } catch (error) {
      this.props.decaActions.setDisableAllSolicitacao(true);
      this.props.solicitacaoActions.setCCM(undefined);

      this.props.solicitacaoActions.resetForm(
        "",
        solicitacao.TipoSolicitacao,
        true,
        solicitacao.CpfCnpjSolicitacao,
        false
      );
      return 1;
    }
  }

  async onChangeCCM(ccm) {
    let { form, solicitacaoSelector, solicitacaoActions } = this.props;
    const { solicitacao } = solicitacaoSelector;
    if (ccm && ccm != solicitacao.CCM && solicitacao.CCM) {
      const result = await _alert.confirm(
        "Houve alteração nos campos CPF/CNPJ, Tipo Solicitação e CCM, deseja realmente confirmar essa Alteração ? Note que os dados preenchidos serão perdidos.",
        "Atenção"
      );
      if (!result) {
        solicitacaoActions.setCCM("");
        solicitacaoActions.setCCM(solicitacao.CCM);
        return;
      } else {
        solicitacaoActions.setCCM(solicitacao.CCM);
      }
    }

    const { CpfCnpjSolicitacao, TipoSolicitacao } = form.values;
    if (ccm && CpfCnpjSolicitacao && TipoSolicitacao) {
      let retorno = await this.dadosSolicitacao(
        CpfCnpjSolicitacao,
        TipoSolicitacao,
        ccm
      );

      if (retorno == 1) return;
    }

    this.props.solicitacaoActions.setSolicitacao({
      TipoSolicitacao,
    });
  }

  getTipoSolicitacao() {
    const { deca } = this.props.decaSelector;
    const { registrarSolicitacao } = deca;
    const { parametro } = registrarSolicitacao;
    const cadastro =
      parametro &&
      parametro.filter(
        (x) => x.Descricao === "SolicitacaodeCadastro" && x.Valor === "S"
      )[0];

    const alteracao =
      parametro &&
      parametro.filter(
        (x) => x.Descricao === "SolicitacaodeAlteracao" && x.Valor === "S"
      )[0];

    const encerramento =
      parametro &&
      parametro.filter(
        (x) => x.Descricao === "SolicitacaodeEncerramento" && x.Valor === "S"
      )[0];

    let itens = [];

    if (cadastro) itens.push({ Valor: cadastro.Codigo, Texto: "Cadastro" });
    if (alteracao) itens.push({ Valor: alteracao.Codigo, Texto: "Alteração/Renovação" });
    if (encerramento)
      itens.push({ Valor: encerramento.Codigo, Texto: "Encerramento" });

    return itens;
  }

  showMotivoRetificacao() {
    const { routerManager } = this.props;
    const { solicitacao } = this.props.solicitacaoSelector;

    return (
      !!routerManager.params.id &&
      (solicitacao.SituacaoSolicitacao == 1 ||
        solicitacao.SituacaoSolicitacao == 2 ||
        solicitacao.SituacaoSolicitacao == 8)
    );
  }

  edit() {
    const { solicitacao } = this.props.solicitacaoSelector;

    return (
      solicitacao.SituacaoSolicitacao == 1 ||
      solicitacao.SituacaoSolicitacao == 2 ||
      solicitacao.SituacaoSolicitacao == 8
    );
  }

  render() {
    const { Campos } = DDados;
    const { solicitacao } = this.props.solicitacaoSelector;
    const {
      form,
      prefix,
      disableAll,
      habilitaSolicitacao,
      disableAllDadosCadastrais,
      retificarDadosCadastrais,
    } = this.props;
    const isView = prefix == "V";
    const retificar = prefix == "R";

    return (
      <Fragment>
        <Panel title="Solicitação" expanded={true} expandedFix={true}>
          {(isView || retificar) && (
            <Row>
              <Col lg={6}>
                <DDadosItem
                  name="Numero"
                  {...Campos.Numero}
                  state={solicitacao}
                  Desabilitado={true}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={3}>
              <DDadosItem
                name="CpfCnpjSolicitacao"
                onBlur={this.handleCpfCnpjBlur}
                {...Campos.CpfCnpjSolicitacao}
                state={solicitacao}
                isView={isView || prefix == "R"}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="TipoSolicitacao"
                onChange={(e) => this.onChangeTipoSolicitacao(e)}
                {...Campos.TipoSolicitacao}
                itens={this.getTipoSolicitacao()}
                state={solicitacao}
                Desabilitado={habilitaSolicitacao}
                isView={isView || retificar}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="CCM"
                onChange={this.onChangeCCM}
                {...Campos.CCM}
                state={solicitacao}
                itens={solicitacao.itensComboboxCCM}
                Desabilitado={
                  (solicitacao.itensComboboxCCM.length == 0 &&
                    form.values.TipoSolicitacao == "1") ||
                  solicitacao.itensComboboxCCM.length == 0 ||
                  (solicitacao.itensComboboxCCM.length > 0 &&
                    form.values.TipoSolicitacao == "1") ||
                  form.values.TipoSolicitacao == undefined ||
                  form.values.TipoSolicitacao == ""
                }
                isView={isView || retificar}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="SituacaoSolicitacaoDescricao"
                {...Campos.SituacaoSolicitacaoDescricao}
                state={solicitacao}
                isView={isView || prefix == "R" || disableAll}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DDadosItem
                name="DescricaoSolicitacao"
                {...Campos.DescricaoSolicitacao}
                state={solicitacao}
                isView={isView || !this.edit()}
                onChange={(value) => this.handlerDescricaoSolicitacao(value)}
              />
            </Col>
          </Row>
          {this.showMotivoRetificacao() && (
            <Row>
              <Col>
                <DDadosItem
                  name="MotivoRetificacao"
                  {...Campos.MotivoRetificacao}
                />
              </Col>
            </Row>
          )}

          <Row>
            <Col>
              <DadosCadastrais
                form={form}
                isView={isView}
                retificar={retificarDadosCadastrais}
                disableAll={disableAllDadosCadastrais}
              />
            </Col>
          </Row>
        </Panel>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    solicitacaoActions,
    decaActions,
    documentoActions,
  },
  selectors: {
    solicitacaoSelector,
    decaSelector,
  },
})(Container);